const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development"
require("dotenv").config({
  path: `.env.${activeEnv}`,
})

module.exports = {
  pathPrefix: process.env.PATH_PREFIX,
  
  siteMetadata: {
    title: `Etiqa Insurance`,
    description: ``,
    author: `@etiqa.com.sg`,

    // -------------------------------

    apiPreFix: process.env.API_PREFIX,

    // -------------------------------
    themeIcon: process.env.THEME_ICON,
    themeLogo: process.env.THEME_LOGO,
    theme: process.env.THEME,

  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    // {
    //   resolve: `gatsby-plugin-manifest`,
    //   options: {
    //     name: `gatsby-starter-default`,
    //     short_name: `starter`,
    //     start_url: `/`,
    //     background_color: `#663399`,
    //     theme_color: `#663399`,
    //     display: `minimal-ui`,
    //     //icon: `src/content/img/tiqicon.png`, // Tiq Theme Icon
    //     // icon: `src/content/img/etiqaicon.png`, // Etiqa Theme Icon
    //   },
    // },
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
  ],
}
